import React, { useRef, useEffect } from 'react';

/**
 * AutoTextarea: Notion/Substack style auto-expanding textarea
 * Expands dynamically as text is typed, completely eliminating cramped inner scrollbars.
 */
const AutoTextarea = ({
    value,
    onChange,
    placeholder = '',
    minRows = 1,
    className = '',
    style = {},
    ...rest
}) => {
    const textareaRef = useRef(null);

    const resize = () => {
        const node = textareaRef.current;
        if (!node) return;
        node.style.height = 'auto';
        node.style.height = `${Math.max(node.scrollHeight, minRows * 24)}px`;
    };

    useEffect(() => {
        resize();
    }, [value, minRows]);

    return (
        <textarea
            ref={textareaRef}
            value={value || ''}
            onChange={(e) => {
                resize();
                if (onChange) onChange(e);
            }}
            placeholder={placeholder}
            rows={minRows}
            className={`auto-expand-textarea ${className}`}
            style={{
                width: '100%',
                resize: 'none',
                overflow: 'hidden',
                boxSizing: 'border-box',
                fontFamily: 'inherit',
                fontSize: '15px',
                lineHeight: '1.6',
                ...style
            }}
            {...rest}
        />
    );
};

export default AutoTextarea;
